import { MessageCircle, LogIn } from "lucide-react";
import { waLink, CENTRAL_URL } from "@/lib/site";
import { Reveal } from "./Reveal";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="footer"
      className="relative overflow-hidden border-t border-white/10 bg-surface"
    >
      <div className="mx-auto max-w-7xl px-5 pb-12 pt-24 sm:px-8 sm:pt-32">
        <Reveal>
          <p className="font-mono text-xs tracking-[0.35em] text-violet-400">
            / FALE COM A GENTE
          </p>
          <h2 className="mt-5 max-w-3xl font-display text-5xl font-black tracking-tight sm:text-7xl">
            Pronto pra navegar na velocidade máxima?
          </h2>
          <div className="mt-10 flex flex-wrap items-center gap-4">
            <a
              data-testid="footer-cta"
              href={waLink("Olá! Quero assinar um plano da HPNET.")}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 rounded-md bg-violet-600 px-8 py-4 text-sm font-medium text-white shadow-[0_0_40px_rgba(124,58,237,0.45)] transition-colors duration-200 hover:bg-violet-500"
            >
              <MessageCircle className="h-5 w-5" />
              Chamar no WhatsApp
            </a>
            <a
              data-testid="footer-central-link"
              href={CENTRAL_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 rounded-md border border-white/10 bg-white/5 px-8 py-4 text-sm font-medium text-white transition-colors duration-200 hover:bg-white/10"
            >
              <LogIn className="h-5 w-5" />
              Central do Assinante
            </a>
          </div>
        </Reveal>
      </div>

      <div
        aria-hidden="true"
        className="pointer-events-none select-none text-center font-display text-[22vw] font-black leading-[0.75] text-white/[0.04]"
      >
        HPNET
      </div>
      <div className="relative border-t border-white/10 py-5 text-center text-xs text-white/40">
        © {year} HPNET — Internet em Bertioga/SP
      </div>
    </footer>
  );
}
